import type {
  EventHandlerCb,
  ExtendedConstraints,
  CapabilityConfig,
} from '../../types';
import { hasOnlyKeysFromSet } from '../../utils';

export const id = 'storage';

export enum Events {
  Update = 'storage:update',
}
export enum Actions {
  Set = 'storage:set',
  Request = 'storage:request',
}

export type UpdatePayload = Record<string, unknown>;

const VALID_CONFIG_KEYS = ['type'] as const;
export type Config = CapabilityConfig & {
  type: typeof id;
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;

  eventPayloadTuple: [Events.Update, UpdatePayload];
  eventHandlerTuple: [Events.Update, EventHandlerCb<UpdatePayload>];
  actionPayloadTuple: [Actions.Set, UpdatePayload] | [Actions.Request];
}>;

export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!hasOnlyKeysFromSet(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
